import { useTheme } from '@material-ui/core';
import * as React from 'react';
import DocumentTitle from 'react-document-title';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { dataPanelContainerStyles } from '../components/data-panel';
import { Header } from '../components/header';
import { Outreaches } from '../components/outreaches';

const OutreachesComponent: React.FC<RouteComponentProps> = ({ location }) => {
    const theme = useTheme();
    const view = location.pathname?.match(/^\/outreach-schedules/)
        ? 'outreach-schedules'
        : location.pathname?.match(/^\/outreach-search-result-counts/)
          ? 'outreach-search-result-counts'
          : 'outreaches';
    const title =
        view === 'outreach-schedules'
            ? 'Outreach Schedules'
            : view === 'outreach-search-result-counts'
              ? 'Outreach Search Result Counts'
              : 'Outreaches';
    return (
        <DocumentTitle title={title}>
            <div id="container">
                <Header title={title} />
                <div css={dataPanelContainerStyles(theme)}>
                    <Outreaches view={view} />
                </div>
            </div>
        </DocumentTitle>
    );
};

export const OutreachesPage = withRouter(OutreachesComponent);
